module.exports = __webpack_public_path__ + "img/close-gallery.bd206601.svg";